<template>
  <el-container class="main-layout">
    <!-- 移动端遮罩层 -->
    <div v-if="sidebarVisible" class="mobile-overlay" @click="toggleSidebar"></div>
    
    <!-- 侧边栏 -->
    <el-aside :width="sidebarWidth" class="sidebar" :class="{ 'sidebar-mobile': isMobile, 'sidebar-visible': sidebarVisible }">
      <div class="logo">
        <h2>网课销售管理系统</h2>
        <i v-if="isMobile" class="el-icon-close close-btn" @click="toggleSidebar"></i>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="sidebar-menu"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409eff"
        router
        @select="handleMenuSelect"
      >
        <el-menu-item index="/">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/course">
          <i class="el-icon-goods"></i>
          <span slot="title">网课商品管理</span>
        </el-menu-item>
        <el-menu-item index="/article">
          <i class="el-icon-document"></i>
          <span slot="title">私人订制</span>
        </el-menu-item>
        <el-menu-item index="/order">
          <i class="el-icon-s-order"></i>
          <span slot="title">订单管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header">
        <div class="header-left">
          <i v-if="isMobile" class="el-icon-menu mobile-menu-btn" @click="toggleSidebar"></i>
          <span class="header-title">网课销售管理系统</span>
        </div>
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="user-info">
              <i class="el-icon-user"></i>
              <span class="username-text">{{ username }}</span>
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main class="main-content">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { logout } from '@/utils/auth'
import { getUsername } from '@/utils/auth'

export default {
  name: 'MainLayout',
  data() {
    return {
      username: '',
      sidebarVisible: false,
      isMobile: false
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
    sidebarWidth() {
      return this.isMobile ? '200px' : '200px'
    }
  },
  mounted() {
    this.username = getUsername() || '管理员'
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) {
        this.sidebarVisible = false
      }
    },
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible
    },
    handleMenuSelect() {
      // 移动端选择菜单后自动关闭侧边栏
      if (this.isMobile) {
        this.sidebarVisible = false
      }
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          logout()
          this.$router.push('/login')
          this.$message({
            type: 'success',
            message: '退出成功!'
          })
        }).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.main-layout {
  height: 100vh;
}

.sidebar {
  background-color: #304156;
  overflow: hidden;
}

.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: #2b3a4a;
  border-bottom: 1px solid #1f2d3d;
}

.logo h2 {
  margin: 0;
  font-size: 16px;
  color: #fff;
  font-weight: 600;
}

.sidebar-menu {
  border-right: none;
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.header {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.header-left {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  cursor: pointer;
  color: #606266;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-info:hover {
  color: #409eff;
}

.main-content {
  background-color: #f0f2f5;
  padding: 20px;
  overflow-y: auto;
  height: calc(100vh - 60px);
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .main-layout {
    position: relative;
  }

  .sidebar {
    position: fixed;
    left: -200px;
    top: 0;
    bottom: 0;
    z-index: 1001;
    transition: left 0.3s ease;
    width: 200px !important;
  }

  .sidebar.sidebar-visible {
    left: 0;
  }

  .mobile-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: block;
  }

  .logo {
    position: relative;
  }

  .close-btn {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #fff;
    font-size: 20px;
    cursor: pointer;
  }

  .header {
    padding: 0 15px;
    height: 50px !important;
    line-height: 50px;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .mobile-menu-btn {
    font-size: 20px;
    cursor: pointer;
    color: #303133;
  }

  .header-title {
    font-size: 16px;
  }

  .header-right {
    font-size: 14px;
  }

  .username-text {
    display: none;
  }

  .main-content {
    padding: 15px;
    height: calc(100vh - 50px);
  }
}

@media screen and (max-width: 480px) {
  .header-title {
    font-size: 14px;
  }

  .main-content {
    padding: 10px;
  }
}
</style>

